import { CustomTabSwitcher } from "../../../components/Tab/TabSection";
import React, { useEffect, useState } from 'react';
import ContainerDetails from "./components/ContainerDetails";
import CargoDetails from "./components/CargoDetails";
import { containerDetailsData, cargoDetailsData } from "../../../common/staticData";

// Example usage with demo data
interface CargoPageProps {
  trackingUrl?: string;
  tripId?: string;
}

const CargoPage: React.FC<CargoPageProps> = ({ trackingUrl, tripId }) => {
  const [containerData, setContainerData] = useState<any>([]);
  const [cargoData, setcargoData] = useState<any>([]);
  const tabs = [
    { label: 'Container', key: 'container', count: 3 },
    { label: 'Cargo', key: 'cargo', count: 3 }
  ];

  const demoData = {
    container: containerData,
    cargo: [{ id: 1, name: 'Cargo Item 1' }, { id: 2, name: 'Cargo Item 2' }]
  };
  useEffect(() => {
    setContainerData(containerDetailsData)
    setcargoData(cargoDetailsData)
  }, [])

  // Define different render functions for each tab
  const renderMap = {
    container: (item: any) => (
      <div>
        <ContainerDetails
          container={containerData}
          setContainer={setContainerData}
          trackingUrl={trackingUrl}
          tripId={tripId}
        />
      </div>
    ),
    cargo: (item: any) => (
      <div>
        <CargoDetails cargo={cargoData} setContainer={setcargoData} />
      </div>
    )
  };

  return (
    <div className="w-full m-2">
      <CustomTabSwitcher
        tabs={tabs}
        data={demoData}
        renderMap={renderMap}
        onAddClick={() => console.log('Add clicked')}
        onSearch={(query) => console.log('Search:', query)}
      />
    </div>
  );
};

export default CargoPage;